const styles = {
    navText: {
        fontWeight: 600,
        letterSpacing: 1,
        cursor: 'pointer',
        color: "#373737"
    },
    logo: {
        display: 'inline',
        position: 'relative',
        bottom: 10,
        right: 5,
        height: 40
    },
    brand: {
        letterSpacing: 4,
        fontWeight: 600,
        color: "#373737",
        position: 'relative',
        bottom: 7,
        textDecoration: 'none'
    }
}

export default styles;


// WEBPACK FOOTER //
// ./src/components/Navbar/2/Navbar2Style.js